<div class="general-assistant">
  <div class="conversation-starters-wrapper">
    <div class="assistant-sub-header">
      {{ assistantContent.conversationStarters.title }}
    </div>
    @if (displaySubtitle()) {
      <div class="conversation-info">
        {{ assistantContent.conversationStarters.subtitle }}
      </div>
    }
    @if (displayNoPromptMessage()) {
      <div class="conversation-info">{{ assistantContent.conversationStarters.noPrompt }}</div>
    } @else {
      <u-input-list
        [initialList]="conversationStarterList()"
        [limit]="4"
        [placeholder]="assistantContent.conversationStarters.placeholder"
        [state]="viewOnly ? 'readonly' : !isAssistantEditable ? 'disabled' : ''"
        (onUpdatedList)="onUpdateConversationsList($event)"
      ></u-input-list>
    }
  </div>
  <div class="assistant-access-wrapper">
    <div class="assistant-sub-header">
      {{ assistantContent.access }}
    </div>
    <div class="access-toggles">
      <toggle-with-text
        [title]="'Display on Chat'"
        [subtitle]="'Make this assistant available on the Chat page for all users with \'Interact\' permission.'"
        [checked]="displayOnChatPage()"
        [isViewer]="viewOnly"
        [disabled]="!isAssistantEditable"
        (toggleChange)="toggleDisplayOnChatPage($event)"
      >
      </toggle-with-text>
      @if (assistantId === defaultAssistant()?.assistant?.id && !displayOnChatPage()) {
        <div class="access-toggle-warning">
          <u-icon
            [model]="{ type: 'font', value: 'icon-info' }"
            [styles]="{ color: 'var(--yellow-600)', fontSize: '16px' }"
            tooltipPosition="top"
            tooltipStyleClass="u-tooltip"
          ></u-icon>
          <span class="warning-text">
            This assistant powers writing and reading tools in the browser extension. Removing it from chat will disable these features.
          </span>
        </div>
      }
      @if (displayOnChatPage()) {
        <toggle-with-text
          class="general-toggle"
          [title]="'Display on quick search'"
          [subtitle]="'Make this assistant available for questions on the Homepage, launch bar, browser extension, etc.'"
          [checked]="displayOnQuickSearch()"
          [isViewer]="viewOnly"
          [disabled]="!isAssistantEditable"
          (toggleChange)="toggleDisplayOnQuickSearch($event)"
        >
        </toggle-with-text>
      }
    </div>
  </div>
</div>
